const apiUrl = process.env.REACT_APP_API_URL;

// Borra una penalización por id.
export const DeletePenalitzacio = async (id_penalitzacio: string | number) => {
    try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(
            `${apiUrl}:8061/jutge/penalitzacio/${id_penalitzacio}`,
            {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });
        return response.ok;
    } catch (error) {
        console.log('Error esborrant penalització:', error);
        return false;
    }
};
